import React, { useState, useEffect } from 'react'
import objectPath from 'object-path'
import { Button } from 'react-bootstrap'
import ExternalModal from './ExternalModal'
import PatientSearchModal from 'views/panels/hospital/PatientRegister/components/PatientSearchModal'
import PatientVisitSearchModal from 'views/panels/hospital/PatientRegister/components/PatientVisitSearchModal'
import PatientAdmissionSearchModal from 'views/panels/hospital/PatientRegister/components/PatientAdmissionSearchModal'

const DesignerModal = ({
  component = {
    data: {
      /*  
        รับ data จาก component และส่งไป designer
        ต้องสร้าง prop ชื่อ "data" ประเภท "input/formData" ใน designer 
        เพื่อรับ data จาก component ไปยัง input หรือ form data ใน designer
      */
    },
    setData: () => {
      // set state ของ data จาก component
    },
    defaultData: {
      // รับ structure data เพื่อใช้ผูก data จาก designer และส่งกลับไป component
    },
    defaultProps: {
      /* 
        รับค่า prop เพื่อผูกค่าที่ส่งมาจาก component เข้าในระบบ designer
        ต้องสร้าง prop ประเภท "system" ใน designer เพื่อรับค่า prop
        เช่น "isPublic" : 1 ให้สร้าง prop ชื่อ "isPublic" ใน designer
      */
    },
  },
  code = {
    form: '', // รับ form code
    page: '', // รับ page code
  },
  callback = {
    /* 
      รับ callback สำหรับ call function จาก component ผ่านปุ่มใน designer
      ต้องสร้าง prop ประเภท "callback" ใน designer เพื่อรับค่า callback
      เช่น "saveCallback" : onSave() ให้สร้าง prop ชื่อ "saveCallback" ใน designer
    */
  },
  buttonProps = {
    // button props
    title: 'button',
    variant: 'outline-success',
    component: null, // button component
    state: {}, // button state
  },
  modalProps = {
    // modal props
    size: 'lg',
    modalHeaderStyle: { backgroundColor: '#FFF' },
    textHeaderStyle: { color: '#000' },
  },
}) => {
  const {
    data,
    setData,
    defaultData = component.data,
    defaultProps,
  } = component
  const {
    modal: [modalCode, setModalCode],
  } = {
    modal: useState(false),
    ...buttonProps.state,
  }

  const { form, page } = code
  const [render, setRender] = useState(false)
  const onOpenModal = (modalCode) => setModalCode(modalCode)
  const onCloseModal = () => setModalCode(false)

  // update data ที่ได้จาก designer ไปยัง component
  const onUpdateData = (designerData) => {
    let newData = objectPath.get(designerData, `data`)
    setData({ ...data, ...newData })
  }

  // update data ที่ได้จาก row table ใน designer ไปยัง component
  const onSelectRow = (rowData) => {
    setData({ ...data, ...rowData })
    if (modalCode) {
      onCloseModal()
    }
    setRender(true)
  }

  useEffect(() => {
    if (render) {
      setRender(false)
    }
  }, [render])

  return (
    <React.Fragment>
      {buttonProps.component ? (
        buttonProps.component
      ) : (
        <Button
          variant={buttonProps.variant}
          onClick={() => onOpenModal(form || page)}
        >
          {buttonProps.title}
        </Button>
      )}
      {page === 'page-rpt-search-hn' ? (
        <PatientSearchModal
          show={modalCode === page}
          onHide={onCloseModal}
          onSelect={(patient) => {
            onSelectRow(patient)
            callback.selectCallback?.(patient)
          }}
        />
      ) : page === 'page-rpt-search-vn' ? (
        <PatientVisitSearchModal
          show={modalCode === page}
          onHide={onCloseModal}
          onSelect={(visit) => {
            onSelectRow(visit)
            callback.selectCallback?.(visit)
          }}
        />
      ) : page === 'page-rpt-search-an' ? (
        <PatientAdmissionSearchModal
          show={modalCode === page}
          onHide={onCloseModal}
          onSelect={(admission) => {
            onSelectRow(admission)
            callback.selectCallback?.(admission)
          }}
        />
      ) : <ExternalModal
        code={code}
        modalCode={modalCode}
        onCloseModal={onCloseModal}
        data={data}
        designerData={defaultData}
        defaultProps={defaultProps}
        callback={{
          ...callback,
          '@onSelectRow': onSelectRow,
        }}
        modalProps={modalProps}
        onSelectRow={onSelectRow}
        onUpdateData={onUpdateData}
      />}
    </React.Fragment>
  )
}

// กำหนด default props เพื่อใช้ผูก prop จาก component กับ ระบบ
DesignerModal.defaultProps = {
  component: {
    data: {},
    setData: () => {},
    defaultData: {},
    defaultProps: {},
  },
  code: {
    form: '',
    page: '',
  },
  callback: {},
  buttonProps: {
    title: 'button',
    variant: 'outline-success',
    component: <Button></Button>,
  },
  modalProps: {
    size: 'lg',
    modalHeaderStyle: { backgroundColor: '#FFF' },
    textHeaderStyle: { color: '#000' },
  },
}

export default DesignerModal
